"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetType = void 0;
var WidgetType;
(function (WidgetType) {
    WidgetType["PROTECTION_STATUS"] = "ProtectionStatus";
    WidgetType["DATABASES_UPDATE_STATUS"] = "DatabasesUpdateStatus";
})(WidgetType || (exports.WidgetType = WidgetType = {}));
